import * as React from 'react'
import type { BrandDto } from '@lib/dto/brand.dto'

/**
 * Applies an organization's corners and font (its brand settings) while a
 * signer page is open. They go on <html>, like the accent, so dialogs portaled
 * to <body> match; design-system/tokens.css maps them to the radius and font
 * tokens. PixelSign's own look (`medium`, `inter`) sets nothing.
 */
export function useBrandLook(brand: Pick<BrandDto, 'cornerRadius' | 'fontFamily'> | undefined): void {
  const radius = brand?.cornerRadius
  const font = brand?.fontFamily
  React.useEffect(() => {
    const root = window.document.documentElement
    if (radius && radius !== 'medium') root.setAttribute('data-radius', radius)
    if (font && font !== 'inter') root.setAttribute('data-font', font)
    return () => {
      root.removeAttribute('data-radius')
      root.removeAttribute('data-font')
    }
  }, [radius, font])
}
